import api from './api';

export default {
  getFeeTiers(parentId) {
    return new Promise((resolve, reject) => {
      api
        .get('fee-tier', {
          params: {
            filters: {
              where: [['parent_id', '=', parentId]]
            },
            orderby: 'amount,asc'
          }
        })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  updateFeeTier(id, updates) {
    return new Promise((resolve, reject) => {
      api
        .put(`fee-tier/${id}`, { updates })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  addFeeTier(feeTier) {
    return new Promise((resolve, reject) => {
      api
        .post(`fee-tier`, feeTier)
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  deleteFeeTier(id) {
    return new Promise((resolve, reject) => {
      api
        .delete(`fee-tier/${id}`)
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  }
};
